<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              <div class="d-flex align-end">
                Choose period
                <div class="ml-5">
                  <DatePicker
                    v-model="month"
                    label="Period"
                    type="month"
                    dense
                    @onDatePickerChange="getAnniversary"
                  />
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-data-table
                dense
                class="data-table"
                group-by="Event_Type"
                fixed-header
                mobile-breakpoint="0"
                :height="tableHeight"
                :headers="headers"
                :items="employee"
                :search="search"
                :items-per-page="-1"
                :item-class="rowItemsClass"
                hide-default-footer
                sort-by="Event_Type"
              >
                <template v-slot:[`group.header`]='{ group, toggle, isOpen }'>
                  <td :colspan="headers.length"
                    class="primary white--text"
                    :class="{
                      'darken-1': group === 'Birthday',
                      'darken-2': group === 'Rest'
                    }"
                  >
                    {{ group }}
                    <v-btn icon color="white" @click="toggle">
                      <v-icon>mdi-18px {{ isOpen ? 'mdi-arrow-up-drop-circle' : 'mdi-arrow-down-drop-circle' }}</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template v-slot:[`item.Full_Name`]="{ item }">
                  <span
                    @click.stop="openEmployeeCard(item.Employee_ID)"
                    style="cursor: pointer; text-decoration: underline;"
                    :class="{
                      'orange-bg' : item.Will_Leave_Company
                    }"
                  >
                    {{ item.Full_Name }}
                  </span>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'

export default {
  name: 'Anniversary',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  data () {
    return {
      today: formatLocalDate(),
      month: '',
      search: '',
      employee: [],
      headers: [
        {
          text: 'Full Name',
          value: 'Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Position',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Supervisor Full Name',
          value: 'Supervisor_Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Department',
          value: 'Department',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Date Of Birth',
          value: 'Birth',
          divider: true,
          class: 'px-2 text-no-wrap',
          sortable: false
        },
        {
          text: 'Hiring Date',
          value: 'Hiring_Date',
          divider: true,
          class: 'px-2 text-no-wrap',
          sortable: false
        },
        {
          text: 'Month Of Work',
          value: 'Month_Of_Work',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Years Of Work',
          value: 'Years_Of_Work',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Contract Type',
          value: 'Contract_Type',
          class: 'px-2 text-no-wrap'
        }
      ]
    }
  },
  computed: {
    tableHeight () {
      const windowW = window.innerWidth
      return windowW < 768 ? 'calc(100vh - 280px)' : 'calc(100vh - 210px)'
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
    this.month = new Date().toISOString().substring(0, 7)
    this.getAnniversary()
  },
  methods: {
    openEmployeeCard (employeeID) {
      this.axios.get(`/api/employee/${employeeID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.$store.dispatch('employeeDetailsScreen', {
          show: true,
          employee: res.data[0],
          edit: false
        })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    rowItemsClass (item) {
      const itemHiringDate = new Date(item.Hiring_Date)
      const itemBirthDate = new Date(item.Birth)
      const today = new Date()
      const isAnniversary = itemHiringDate.getMonth() === today.getMonth() &&
        itemHiringDate.getDate() === today.getDate() && item.Event_Type === 'Anniversary'
      const isBirthday = itemBirthDate.getMonth() === today.getMonth() &&
        itemBirthDate.getDate() === today.getDate() && item.Event_Type === 'Birthday'
      if (isAnniversary || isBirthday) {
        return this.$vuetify.theme.dark ? 'success' : 'success lighten-5'
      }
    },
    getAnniversary () {
      this.axios.get(`/api/anniversary/${this.month}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        const anniversaryAndBirthday = []
        this.employee = res.data.map(empl => {
          empl.Event_Type = 'Rest'
          if (empl.Anniversary) empl.Event_Type = 'Anniversary'
          if (empl.Birthday) empl.Event_Type = 'Birthday'
          if (empl.Anniversary && empl.Birthday) anniversaryAndBirthday.push(Object.assign({}, empl))
          return empl
        })
        for (let i = 0; i < anniversaryAndBirthday.length; i++) {
          anniversaryAndBirthday[i].Event_Type = 'Anniversary'
          this.employee.push(anniversaryAndBirthday[i])
        }
        this.employee = this.sortByEventAndDate(this.employee)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    sortByEventAndDate (items) {
      // Filter and sort "Anniversary" employees by Hiring_Date day only
      const anniversaryGroup = items.filter(item => item.Event_Type === 'Anniversary')
        .sort((a, b) => {
          const aDate = new Date(a.Hiring_Date)
          const bDate = new Date(b.Hiring_Date)
          return aDate.getDate() - bDate.getDate()
        })

      // Filter and sort "Birthday" employees by Birth day only
      const birthdayGroup = items.filter(item => item.Event_Type === 'Birthday')
        .sort((a, b) => {
          const aDate = new Date(a.Birth)
          const bDate = new Date(b.Birth)
          return aDate.getDate() - bDate.getDate()
        })

      const restGroup = items.filter(item => item.Event_Type === 'Rest')

      return [...anniversaryGroup, ...birthdayGroup, ...restGroup]
    },
    currentEmployeeAge (dayOfBirth) {
      const birthday = new Date(dayOfBirth)
      const diff = (new Date(this.today)).getTime() - birthday.getTime()
      const ageDate = new Date(diff)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  tr:has(> td > span.orange-bg) {
    background-color: #fff3e0 !important;
  }
}
</style>
